var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.9 105.3",
    style: {
      enableBackground: "new 0 0 122.9 105.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0A1E3C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.5,2.3L72,2.8c0.5,0,1-0.1,1.6-0.1L120.7,54c3.2,3.5,2.8,8.9-0.7,12.1l-41.5,37c-3,2.7-7.5,2.8-10.7,0.5 l42.5-37.9c3.7-3.3,4.1-9.2,0.7-12.9L64.5,2.3L64.5,2.3z M53.1,3.2l45.5,49.6c3.1,3.3,2.7,8.6-0.7,11.7l-40.1,35.7 c-3.4,3-8.6,2.7-11.7-0.7l-42.8-48l0.1-1.4L0,0l51.5,3.3C52,3.2,52.6,3.2,53.1,3.2L53.1,3.2z M20.1,9.8c5.1,0.1,9.2,4.3,9,9.5 s-4.3,9.2-9.4,9c-5.1-0.1-9.2-4.3-9-9.5C10.7,13.7,15,9.7,20.1,9.8L20.1,9.8z M28.3,44.7l29.4,32.1l-5.9,5.4L22.4,50.1L28.3,44.7 L28.3,44.7z M41.3,33.1l29.4,32.1l-5.9,5.4L35.4,38.5L41.3,33.1L41.3,33.1z M53.1,22.1l29.4,32.1l-5.9,5.4L47.2,27.4L53.1,22.1 L53.1,22.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsIcon);
export default __webpack_public_path__ + "static/media/tags-icon.65c2cc031e0a997c167fef14087573ea.svg";
export { ForwardRef as ReactComponent };